<template>
  <div class="wrap">
    <privacyPolicyTxt />
  </div>
</template>

<script>
import privacyPolicyTxt from '../components/privacyPolicyTxt';

export default {
  name: 'privacyPolicy',
  components: {
    privacyPolicyTxt,
  },
  setup() {},
}
</script>

<style></style>
